import { TextInput } from "react-admin";

const kindFilterList = [
  <TextInput
    source="name"
    label="mine.label.name"
    variant="outlined"
    alwaysOn
    resettable
  />,
];

export default kindFilterList;
